import { render, staticRenderFns } from "./SlideWhitesColorbond.vue?vue&type=template&id=194b9c37&"
import script from "./SlideWhitesColorbond.vue?vue&type=script&lang=js&"
export * from "./SlideWhitesColorbond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports